export default class Login {
  public email? : string;
  public password? : string;
}
